import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getSize } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { getThemeColor } from "./auth-service-tools208.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import classes from "./auth-service-tools355.js";
const defaultProps = {
  orientation: "horizontal"
};
const varsResolver = createVarsResolver((theme, _ref) => {
  let {
    color,
    variant,
    size
  } = _ref;
  return {
    root: {
      "--divider-color": color ? getThemeColor(color, theme) : void 0,
      "--divider-border-style": variant,
      "--divider-size": getSize(size, "divider-size")
    }
  };
});
const Divider = factory((_props, ref) => {
  const props = useProps("Divider", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    color,
    orientation,
    label,
    labelPosition,
    mod,
    ...others
  } = props;
  const getStyles = useStyles({
    name: "Divider",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
    ref,
    mod: [{
      orientation,
      "with-label": !!label
    }, mod],
    ...getStyles("root"),
    ...others,
    role: "separator",
    children: label && /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
      component: "span",
      mod: {
        position: labelPosition
      },
      ...getStyles("label"),
      children: label
    })
  });
});
Divider.classes = classes;
Divider.displayName = "@mantine/core/Divider";
export { Divider };